




























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
const login = namespace("login");
@Component({})
export default class Header extends Vue {
  @login.Action loginB2BSSO;
  @login.Action loginZSTSSO;

  locale: string = "id-ID";
  channel: string = "";
  userInfo: any = {};
  tenant: any = {};
  isInit: any = false;
  options: any[] = [
    {
      label: "Locale=EN",
      value: "EN"
    },
    {
      label: "Locale=ID",
      value: "id-ID"
    }
  ];
  channelOptions: any = [
    {
      label: "Channel=default",
      value: ""
    }
  ];
  @Watch("locale")
  onLocaleChange() {
    this.init();
  }
  @Watch("channel")
  onChannelChange() {
    this.init();
  }
  @login.Action logout;
  mounted() {
    this.init();
    setTimeout(() => {
      this.isInit = true;
    }, 5);
  }
  init() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.tenant = JSON.parse(localStorage.getItem("tenant"));
  }
  async handleCommand(command) {
    if (command === "logout") {
      this.handleLogOut();
    }
    if (command === "resetPwd") {
      this.changePassword();
    }
    if (command === "loginLink") {
      try {
        console.log("loginLink");
        const { orgCode } = this.userInfo;
        const {
          data: { api = "" }
        } = await this.loginB2BSSO({
          orgCode
        });
        if (api) {
          this.createDownA(api);
        } else {
          this.$message.error("链接为空！");
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
  async handleLogOut() {
    try {
      await this.logout();
      window.location.reload();
    } catch (error) {
      console.log(error);
    }
  }
  changePassword() {
    this.$router.push({ name: "changePasswordForm" });
  }
  onHeaderClick() {
    this.$router.push("/");
  }
  createDownA(url) {
    let eleLink = document.createElement("a");
    eleLink.style.display = "none";
    eleLink.href = url;
    eleLink.target = "_blank";
    document.body.appendChild(eleLink);
    eleLink.click();
    document.body.removeChild(eleLink);
  }
}
